<div [dragData]="data" [dropZones]="dropZones" dnd-draggable>
    <div (onDropSuccess)="dropped($event.dragData)" [dropZones]="dropZones" class="orderable-item"
         dnd-droppable>
        <div *ngIf="orderable" class="grip">
            <fui-icon [height]="26" [icon]="'drag-2x4'" [width]="21"></fui-icon>
        </div>
        <fui-pill-form-context *ngIf="data" class="form-context">
            <div *ngIf="isDimension && templateRef">
                <ng-container [ngTemplateOutlet]="templateRef"></ng-container>
            </div>
            <div *ngIf="!isDimension || (isDimension && !templateRef)" class="measure-pill">
                <div class="label">
                    {{data.label | translate}} {{isDimension ? "- Not implemented" : ""}}
                </div>
                <div>
                    <fui-mark-button (click)="remove()" class="remove-button">
                        <fui-icon [height]="6" [icon]="'close'" [width]="6"></fui-icon>
                    </fui-mark-button>
                </div>
            </div>
        </fui-pill-form-context>
    </div>
</div>
<!-- Register the search controls -->
<fui-pill-form-context>
    <wbo-bi-dimension-search-control *dimensionControl="'[Product].[product].[product]'">
        <wbo-sellable-multi-select-search-control></wbo-sellable-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Employee].[employee].[employee]'">
        <wbo-employee-multi-select-search-control></wbo-employee-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Outlet].[outlet].[outlet]'">
        <wbo-outlet-multi-select-search-control></wbo-outlet-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Product].[category top level].[category top level]'">
        <wbo-category-multi-select-search-control [maxLevel]="0"></wbo-category-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Product].[category primary].[category primary]'">
        <wbo-category-multi-select-search-control></wbo-category-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[day of week].[day of week]'">
        <wbo-day-of-week-multi-select-search-control></wbo-day-of-week-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Time].[hour of day].[hour of day]'">
        <wbo-hour-of-day-multi-select-search-control></wbo-hour-of-day-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Time].[hour quarter].[hour quarter]'">
        <wbo-hour-quarter-multi-select-search-control></wbo-hour-quarter-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[month of year].[month of year]'">
        <wbo-month-of-year-multi-select-search-control></wbo-month-of-year-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[calendar quarter of year].[calendar quarter of year]'">
        <wbo-calendar-quarter-of-year-multi-select-search-control></wbo-calendar-quarter-of-year-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[date].[date]'">
        <wbo-date-multi-select-search-control [startDate]="cubeDefinition.minAvailableStartDate"
                                              [endDate]="cubeDefinition.maxAvailableEndDate">
        </wbo-date-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[week of year].[week of year]'">
        <wbo-week-of-year-multi-select-search-control></wbo-week-of-year-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[year].[year]'">
        <wbo-year-multi-select-search-control [startDate]="cubeDefinition.minAvailableStartDate"
                                              [endDate]="cubeDefinition.maxAvailableEndDate">
        </wbo-year-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[year by calendar quarter].[year]'">
        <wbo-year-multi-select-search-control [startDate]="cubeDefinition.minAvailableStartDate"
                                              [endDate]="cubeDefinition.maxAvailableEndDate">
        </wbo-year-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Outlet].[state].[state]'">
        <wbo-state-multi-select-search-control></wbo-state-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[year month].[year month]'">
        <wbo-year-month-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                    [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-month-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Date].[year calendar quarter].[year calendar quarter]'">
        <wbo-year-calendar-quarter-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                               [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-calendar-quarter-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Outlet].[location].[location]'">
        <wbo-location-multi-select-search-control></wbo-location-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[SaleComponent].[sale component].[sale component]'">
        <wbo-bi-price-component-multi-select-search-control></wbo-bi-price-component-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[SaleType].[sale type].[sale type]'">
        <wbo-bi-sale-type-multi-select-search-control></wbo-bi-sale-type-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[SellableType].[sellable type].[sellable type]'">
        <wbo-bi-sellable-type-multi-select-search-control></wbo-bi-sellable-type-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[HasEntitlement].[has entitlement].[has entitlement]'">
        <wbo-entitlement-sale-single-select-search-control></wbo-entitlement-sale-single-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Entitlement].[promotion].[promotion]'">
        <wbo-entitlement-promotion-multi-select-search-control></wbo-entitlement-promotion-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[Entitlement].[promotion distribution].[promotion distribution]'">
        <wbo-entitlement-distribution-multi-select-search-control></wbo-entitlement-distribution-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[ExpenseType].[expense type].[expense type]'">
        <wbo-bi-expense-type-multi-select-search-control></wbo-bi-expense-type-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[ExpenseAccount].[expense account].[expense account]'">
        <wbo-account-multi-select-search-control [accountingType]="[1001, 1002]"></wbo-account-multi-select-search-control>
    </wbo-bi-dimension-search-control>
    <wbo-bi-dimension-search-control *dimensionControl="'[KvdDisplay].[display].[display]'">
        <wbo-order-processor-multi-select-search-control [capability]="OrderProcessorCapability.KVD"></wbo-order-processor-multi-select-search-control>
    </wbo-bi-dimension-search-control>
</fui-pill-form-context>
